if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
		});

		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

		/*
		==========================================================
		DOÑA TOMASA - REINICIALIZAR FUNCIONES TRAS RENDER AJAX

		Local sustituye AjaxCartForm y AjaxCartSubtotal mediante
		innerHTML. Los scripts incluidos dentro del HTML sustituido
		no se ejecutan automáticamente.

		Después de cada render del carrito:
		- Reinicializa Fecha de entrega / Flatpickr.
		- Recalcula visibilidad de Caja Especial Regalo.
		==========================================================
		*/

		window.setTimeout(() => {
			if ( typeof window.dtInitDeliveryDate === 'function' ) {
				window.dtInitDeliveryDate();
			}
			if ( typeof window.dtUpdateGiftPackagingVisibility === 'function' ) {
				window.dtUpdateGiftPackagingVisibility();
			}
      // Froonze is outside Local's automatic drawer detection.
      // Reinsert its widget after Local replaces the subtotal HTML.
      const loyaltyAnchor = document.querySelector('#site-cart-sidebar .sidebar__footer .cart__total');
      if (loyaltyAnchor && typeof window.frcp?.loyalty?.installCartWidget === 'function') {
        Promise.resolve(window.frcp.loyalty.installCartWidget(loyaltyAnchor))
          .catch(error => console.warn('[Doña Tomasa] No se pudo actualizar el bloque de puntos.', error));
      }

		}, 0);

		/*
		FIN - DOÑA TOMASA - REINICIALIZAR FUNCIONES TRAS RENDER AJAX
		==========================================================
		*/

		return sectionInnerHTML;

	};
}

(() => {
	if ( window.dtBundleSuiteCartBridgeInitialized ) return;
	window.dtBundleSuiteCartBridgeInitialized = true;

	let waitingForBundle = false;
	let refreshScheduled = false;
	const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
	const wait = milliseconds => new Promise(resolve => window.setTimeout(resolve, milliseconds));
	const previousAfterAdd = typeof window.afterBYOBAddtoCart === 'function'
		? window.afterBYOBAddtoCart
		: null;

	async function getCartItemCount() {
		const response = await fetch(cartUrl, {
			headers: { 'Accept': 'application/json' },
			cache: 'no-store'
		});
		if ( ! response.ok ) throw new Error('No se pudo leer el carrito');
		const cart = await response.json();
		return Number(cart.item_count);
	}

	async function resetBundleBuilder() {
		await wait(250);

		for ( let attempt = 0; attempt < 50; attempt += 1 ) {
			const removeButton = document.querySelector(
				'#bundlesuiteContainer .side-cart-product-container .remove-item-btn, ' +
				'#bundlesuiteContainer .side-cart-product-container .scpt-remove-item button'
			);

			if ( ! removeButton ) return;
			removeButton.click();
			await wait(80);
		}
	}

	async function collapseBundleBuilderCart() {
		const expandedCart = document.querySelector(
			'#bundlesuiteContainer .side-cart-container.mobile-cart:not(.side-cart-shrink)'
		);

		if ( ! expandedCart ) return;

		const toggler = expandedCart.querySelector('.side-cart-toggler');
		if ( toggler ) {
			toggler.click();
			await wait(120);
		}
	}

	async function refreshAndOpenBundleCart() {
		if ( refreshScheduled ) return;
		refreshScheduled = true;

		try {
			await wait(150);
			await resetBundleBuilder();
			await collapseBundleBuilderCart();
			if ( typeof window.refreshCart === 'function' ) {
				await window.refreshCart(true);
			}
		} finally {
			refreshScheduled = false;
		}
	}

	async function refreshBundleCartWhenReady(initialItemCount) {
		for ( let attempt = 0; attempt < 30; attempt += 1 ) {
			await wait(400);
			try {
				const currentItemCount = await getCartItemCount();
				if ( currentItemCount !== initialItemCount ) {
					await refreshAndOpenBundleCart();
					return;
				}
			} catch (error) {
				console.error('Doña Tomasa - Error actualizando el pack:', error);
			}
		}
	}

	/* BundleSuite/BYOB calls this documented hook after a successful add. */
	window.afterBYOBAddtoCart = function() {
		if ( previousAfterAdd ) {
			previousAfterAdd.apply(this, arguments);
		}
		refreshAndOpenBundleCart();
	};

	document.addEventListener('click', event => {
		const duplicateButton = event.target.closest(
			'#bundlesuiteContainer .bundle-step-button.next-step'
		);

		if (
			duplicateButton &&
			/añadir\s+pack\s+al\s+carrito|add\s+bundle\s+to\s+cart/i.test(duplicateButton.textContent || '')
		) {
			const primaryButton = document.querySelector(
				'#bundlesuiteContainer .side-cart-checkout-cta button'
			);

			if ( primaryButton && primaryButton !== duplicateButton ) {
				event.preventDefault();
				event.stopImmediatePropagation();
				primaryButton.click();
				return;
			}
		}

		const button = event.target.closest(
			'#bundlesuiteContainer .side-cart-checkout-cta button, ' +
			'#bundlesuiteContainer button[class*="checkout"], ' +
			'#bundlesuiteContainer button[class*="add-to-cart"]'
		);
		if ( ! button || waitingForBundle ) return;

		const countElement = document.querySelector('[data-header-cart-count]');
		const initialItemCount = Number.parseInt(countElement?.textContent || '0', 10) || 0;
		waitingForBundle = true;

		refreshBundleCartWhenReady(initialItemCount)
			.finally(() => {
				waitingForBundle = false;
			});
	}, true);
})();

if ( window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== 'function' ) {
	KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
		const SE = window.Shopify && window.Shopify.StandardEvents;
		if ( ! SE || typeof SE[className] !== 'function' ) return;
		try {
			( target || document ).dispatchEvent(new SE[className](detail));
		} catch (error) {
			console.warn(`standard-events: ${className}`, error);
		}
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});

						KROWN.functions.dispatchStandardEvent('CartErrorEvent', this, {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					window.renderHelperCart(text);

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = this.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

					if ( alert === null ) {
						KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
							action: newQty === 0 ? 'remove' : 'update',
							context: 'cart',
							lines: [{
								id: item.dataset.id,
								quantity: newQty
							}],
							promise: Promise.resolve({ cart: null })
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		return fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			window.renderHelperCart(text);

			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.#handleSuccess();
									} else {
										this.#handleError();
									}
								} else {
									this.#handleError();
								}
							})
							.catch(error => {
								this.#handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			#handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);

						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						this.input.value = '';

						const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
						if ( this.discountCodes && sectionDiscountCodes ) {
							this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.#loadDiscountButtons();
						}

						const appliedDiscountCodes = sectionDiscountCodes
							? Array.from(sectionDiscountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
							: [];
						KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
							discountCodes: appliedDiscountCodes,
							promise: Promise.resolve({ cart: null })
						});
					})
					.catch(() => this.#handleError())
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}

/*
 * La fecha de entrega se gestiona exclusivamente en assets/delivery-date.js.
 * renderHelperCart llama a window.dtInitDeliveryDate() después de cada render AJAX.
 */


/*
==========================================================
DOÑA TOMASA - MOTOR CAJA ESPECIAL REGALO

ÚNICA fuente JavaScript del módulo.

Gestiona:
- Visibilidad dinámica según las marcas de cart-form.liquid.
- Bundle Suite / bundles nativos.
- Pack / Caja / Cesta.
- Caja Especial ya añadida.
- Reaparición al eliminar el elemento bloqueante.
- Carrusel: flechas y puntos.
- Añadir una sola Caja Especial por AJAX.
- Protección contra doble clic y duplicados.
- Restauración del botón para que vuelva a funcionar si el
  módulo reaparece posteriormente.
==========================================================
*/

(function () {

	function dtGiftGetModule() {
		return document.getElementById('DTGiftPackaging');
	}

	function dtGiftGetCartForm() {
		return document.getElementById('AjaxCartForm');
	}

	/*
	==========================================================
	DOÑA TOMASA - DETECCIÓN DINÁMICA DE BLOQUEO CAJA REGALO

	Comprueba el carrito renderizado en tiempo real.

	Bloquea si:
	- Liquid ya marcó la línea como incompatible.
	- El título del producto empieza por Pack.
	- El título del producto empieza por Cesta.

	La comprobación directa del título sirve como segunda capa
	de seguridad para productos añadidos por flujos AJAX externos.
	==========================================================
	*/

	function dtGiftHasBlockingItem() {
		const cartForm = dtGiftGetCartForm();

		if ( ! cartForm ) return true;

		const cart = cartForm.querySelector('#cart');

		const items = Array.from(
			cartForm.querySelectorAll('[data-js-cart-item]')
		);

		const isEmpty =
			! cart ||
			cart.classList.contains('cart--empty') ||
			items.length === 0;

		if ( isEmpty ) return true;


		const hasBlockingItem = items.some(item => {

			/*
			Primera fuente de verdad:
			marca generada por cart-form.liquid.
			*/
			if (
				item.dataset.dtBlockGiftPackaging === 'true'
			) {
				return true;
			}


			/*
			Segunda capa:
			Pack y Cesta cerrados por nomenclatura.
			*/
			const title = (
				item.dataset.title || ''
			)
				.trim()
				.toLocaleLowerCase('es');

			if (
				title.startsWith('pack') ||
				title.startsWith('cesta')
			) {
				return true;
			}

			return false;

		});

		return hasBlockingItem;
	}

	/*
	FIN - DOÑA TOMASA - DETECCIÓN DINÁMICA DE BLOQUEO CAJA REGALO
	==========================================================
	*/

	window.dtUpdateGiftPackagingVisibility =
		function dtUpdateGiftPackagingVisibility() {

			const module = dtGiftGetModule();

			if ( ! module ) return;

			module.style.display =
				dtGiftHasBlockingItem()
					? 'none'
					: '';
		};


	function dtGiftShowSlide(module, index) {

		const slides = Array.from(
			module.querySelectorAll('[data-dt-gift-slide]')
		);

		const dots = Array.from(
			module.querySelectorAll('[data-dt-gift-dot]')
		);

		if ( ! slides.length ) return;

		index = (index + slides.length) % slides.length;

		slides.forEach((slide, slideIndex) => {
			slide.classList.toggle(
				'is-active',
				slideIndex === index
			);
		});

		dots.forEach((dot, dotIndex) => {
			dot.classList.toggle(
				'is-active',
				dotIndex === index
			);
		});
	}


	async function dtGiftRefreshCart() {

		const response = await fetch(
			'?section_id=helper-cart',
			{
				headers: {
					'Accept': 'text/html'
				}
			}
		);

		if ( ! response.ok ) {
			throw new Error('No se pudo actualizar el carrito');
		}

		const html = await response.text();

		if ( typeof window.renderHelperCart !== 'function' ) {
			throw new Error('renderHelperCart no está disponible');
		}

		window.renderHelperCart(html);
	}


	async function dtGiftCartAlreadyHasVariant(variantId) {

		const response = await fetch(
			'/cart.js',
			{
				headers: {
					'Accept': 'application/json'
				}
			}
		);

		if ( ! response.ok ) return false;

		const cart = await response.json();

		return cart.items.some(
			item => Number(item.variant_id) === Number(variantId)
		);
	}


	document.addEventListener(
		'click',
		async function (event) {

			const module = event.target.closest('#DTGiftPackaging');

			if ( ! module ) return;


			const nextButton = event.target.closest('[data-dt-gift-next]');

			if ( nextButton ) {

				event.preventDefault();

				const slides = Array.from(
					module.querySelectorAll('[data-dt-gift-slide]')
				);

				if ( slides.length < 2 ) return;

				let currentIndex = slides.findIndex(
					slide => slide.classList.contains('is-active')
				);

				if ( currentIndex < 0 ) currentIndex = 0;

				dtGiftShowSlide(module, currentIndex + 1);

				return;
			}


			const previousButton = event.target.closest('[data-dt-gift-prev]');

			if ( previousButton ) {

				event.preventDefault();

				const slides = Array.from(
					module.querySelectorAll('[data-dt-gift-slide]')
				);

				if ( slides.length < 2 ) return;

				let currentIndex = slides.findIndex(
					slide => slide.classList.contains('is-active')
				);

				if ( currentIndex < 0 ) currentIndex = 0;

				dtGiftShowSlide(module, currentIndex - 1);

				return;
			}


			const dot = event.target.closest('[data-dt-gift-dot]');

			if ( dot ) {

				event.preventDefault();

				const index = Number(dot.dataset.dtGiftDot);

				if ( Number.isNaN(index) ) return;

				dtGiftShowSlide(module, index);

				return;
			}


			const addButton = event.target.closest('[data-dt-gift-add]');

			if ( ! addButton ) return;

			event.preventDefault();


			if ( dtGiftHasBlockingItem() ) {
				window.dtUpdateGiftPackagingVisibility();
				return;
			}


			if ( addButton.dataset.dtProcessing === 'true' ) {
				return;
			}


			const variantId = Number(addButton.dataset.variantId);

			if ( ! variantId ) return;


			const originalText =
				addButton.textContent.trim() || 'Añadir';

			addButton.dataset.dtProcessing = 'true';
			addButton.disabled = true;
			addButton.textContent = 'Añadiendo…';


			try {

				const alreadyExists =
					await dtGiftCartAlreadyHasVariant(variantId);

				if ( alreadyExists ) {
					module.style.display = 'none';
					return;
				}


				const response = await fetch(
					'/cart/add.js',
					{
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
						},
						body: JSON.stringify({
							items: [
								{
									id: variantId,
									quantity: 1
								}
							]
						})
					}
				);

				if ( ! response.ok ) {
					throw new Error(
						'No se pudo añadir la Caja Especial Regalo'
					);
				}

				await response.json();

				module.style.display = 'none';

				await dtGiftRefreshCart();

				window.dtUpdateGiftPackagingVisibility();


			} catch (error) {

				console.error(
					'DOÑA TOMASA - Error añadiendo Caja Especial:',
					error
				);


			} finally {

				addButton.disabled = false;
				addButton.dataset.dtProcessing = 'false';
				addButton.textContent = originalText;

			}

		}
	);


	/*
	==========================================================
	DOÑA TOMASA - OBSERVADOR DINÁMICO DEL CARRITO PARA CAJA

	Algunas apps o flujos de Shopify actualizan el carrito por
	AJAX fuera del ciclo habitual de renderHelperCart.

	Este observer vigila AjaxCartForm y recalcula la visibilidad
	del módulo inmediatamente cuando aparecen, desaparecen o
	cambian líneas del carrito.

	El observer se crea una sola vez.
	==========================================================
	*/

	function dtAttachGiftPackagingObserver() {

		const cartForm = dtGiftGetCartForm();

		if (
			! cartForm ||
			window.DTGiftPackagingObserver
		) {
			return;
		}


		let timer = null;

		window.DTGiftPackagingObserver =
			new MutationObserver(function () {

				window.clearTimeout(timer);

				timer = window.setTimeout(
					function () {
						window.dtUpdateGiftPackagingVisibility();
					},
					30
				);

			});


		window.DTGiftPackagingObserver.observe(
			cartForm,
			{
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: [
					'data-title',
					'data-dt-block-gift-packaging',
					'class'
				]
			}
		);

	}

	/*
	FIN - DOÑA TOMASA - OBSERVADOR DINÁMICO DEL CARRITO PARA CAJA
	==========================================================
	*/


	function dtStartGiftPackagingEngine() {
		dtAttachGiftPackagingObserver();
		window.dtUpdateGiftPackagingVisibility();
	}


	if ( document.readyState === 'loading' ) {
		document.addEventListener(
			'DOMContentLoaded',
			dtStartGiftPackagingEngine,
			{ once: true }
		);
	} else {
		dtStartGiftPackagingEngine();
	}

})();

/*
FIN - DOÑA TOMASA - MOTOR CAJA ESPECIAL REGALO
==========================================================
*/
/*
==========================================================
DOÑA TOMASA - MOTOR PERMANENTE CIF/NIF PARA FACTURA

Guarda el valor introducido en el campo de factura como
atributo general del carrito:

attributes[CIF/NIF]

IMPORTANTE:
La clave "CIF/NIF" se mantiene exactamente igual que en
los pedidos históricos para conservar la compatibilidad con Order Printer Pro.

Funcionamiento:
- Escucha mediante delegación para sobrevivir al AJAX.
- Guarda mientras el cliente escribe con debounce.
- Fuerza el guardado al cambiar/salir del campo.
- Normaliza el valor a mayúsculas y elimina espacios extremos.
==========================================================
*/

(function () {

	let dtTaxIdTimer = null;
	let dtTaxIdLastSavedValue = null;

	function dtNormalizeTaxId(value) {
		return String(value || '')
			.trim()
			.toUpperCase();
	}

	function dtSaveTaxId(value) {

		const normalizedValue = dtNormalizeTaxId(value);

		if ( normalizedValue === dtTaxIdLastSavedValue ) {
			return Promise.resolve();
		}

		return fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					'CIF/NIF': normalizedValue
				}
			})
		})
		.then(response => {

			if ( ! response.ok ) {
				throw new Error('No se pudo guardar el CIF/NIF');
			}

			return response.json();

		})
		.then(cart => {

			/*
			DOÑA TOMASA - CIF/NIF / ESCRITURA ESTABLE

			La respuesta AJAX NUNCA vuelve a escribir sobre el input.
			Así evitamos saltos de cursor, caracteres que retroceden o
			respuestas antiguas que pisen lo que el cliente está escribiendo.
			*/

			dtTaxIdLastSavedValue =
				cart.attributes && cart.attributes['CIF/NIF'] !== undefined
					? cart.attributes['CIF/NIF']
					: normalizedValue;

			/*
			FIN - DOÑA TOMASA - CIF/NIF / ESCRITURA ESTABLE
			*/

		})
		.catch(error => {

			console.error(
				'DOÑA TOMASA - Error guardando CIF/NIF:',
				error
			);

		});
	}


	document.addEventListener('input', function (event) {

		if ( event.target.id !== 'DTTaxId' ) return;

		window.clearTimeout(dtTaxIdTimer);

		const value = event.target.value;

		dtTaxIdTimer = window.setTimeout(
			function () {
				dtSaveTaxId(value);
			},
			350
		);

	});


	document.addEventListener('change', function (event) {

		if ( event.target.id !== 'DTTaxId' ) return;

		window.clearTimeout(dtTaxIdTimer);

		const normalizedValue =
			dtNormalizeTaxId(event.target.value);

		event.target.value = normalizedValue;

		dtSaveTaxId(normalizedValue);

	});


	document.addEventListener('blur', function (event) {

		if ( event.target.id !== 'DTTaxId' ) return;

		window.clearTimeout(dtTaxIdTimer);

		const normalizedValue =
			dtNormalizeTaxId(event.target.value);

		event.target.value = normalizedValue;

		dtSaveTaxId(normalizedValue);

	}, true);

})();

/*
FIN - DOÑA TOMASA - MOTOR PERMANENTE CIF/NIF PARA FACTURA
==========================================================
*/


/* DOÑA TOMASA · FROONZE CART · 2026-11-02 */
(() => {
  'use strict';
  const scope = '.frcp-cart-rewards';
  const selector = scope + ' .frcp-loyalty-discount__copy-btn';
  const ready = new WeakSet();
  const timers = new WeakMap();
  let status;
  function announce(text) {
    if (!status) {
      status = document.createElement('span');
      status.className = 'dt-loyalty-copy-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    status.textContent = text;
  }
  function enhance(button) {
    if (ready.has(button)) return;
    ready.add(button);
    button.setAttribute('role', 'button');
    button.setAttribute('tabindex', '0');
    button.setAttribute('aria-label', 'Copiar código de descuento');
    button.setAttribute('title', 'Copiar código de descuento');
    const icon = button.querySelector('svg');
    if (icon) icon.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.className = 'dt-loyalty-copy-label';
    label.textContent = 'Copiar';
    button.appendChild(label);
    let pending = false;
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pending) return;
      const codeElement = button.closest('.frcp-loyalty-discount__code');
      const code = Array.from(codeElement?.childNodes || [])
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent).join('').replace(/^[^:]*:\s*/, '').trim();
      if (!code) { announce('No se ha encontrado el código de descuento.'); return; }
      pending = true;
      try {
        await navigator.clipboard.writeText(code);
        clearTimeout(timers.get(button));
        label.textContent = 'Copiado';
        button.setAttribute('aria-label', 'Código de descuento copiado');
        announce('Código de descuento copiado.');
        timers.set(button, setTimeout(() => {
          label.textContent = 'Copiar';
          button.setAttribute('aria-label', 'Copiar código de descuento');
        }, 2200));
      } catch (error) {
        announce('No se pudo copiar. Selecciona el código y cópialo manualmente.');
      } finally {
        pending = false;
      }
    }, true);
    button.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        button.click();
      }
    });
  }
  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll(selector).forEach(enhance);
  }
  function start() {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
/* FIN · DOÑA TOMASA · FROONZE CART */


/* DOÑA TOMASA · FROONZE: ACTUALIZAR RESUMEN TRAS APLICAR CUPÓN */
(() => {
  'use strict';
  let refreshing = false;
  let refreshAgain = false;
  async function refreshDiscountSummary() {
    if (typeof window.refreshCart !== 'function' || !document.getElementById('AjaxCartSubtotal')) return;
    if (refreshing) { refreshAgain = true; return; }
    refreshing = true;
    try {
      do {
        refreshAgain = false;
        await window.refreshCart(false);
      } while (refreshAgain);
      document.getElementById('site-cart-sidebar')?.classList.remove('dt-loyalty-discount-applying');
    } catch (error) {
      console.error('[Doña Tomasa] No se pudo actualizar el resumen del descuento.', error);
      let notice = document.getElementById('dt-cart-discount-refresh-error');
      if (!notice) {
        notice = document.createElement('p');
        notice.id = 'dt-cart-discount-refresh-error';
        notice.setAttribute('role', 'status');
        document.getElementById('AjaxCartSubtotal')?.appendChild(notice);
      }
      notice.textContent = 'El descuento está aplicado. Actualiza la página para ver el total.';
    } finally {
      refreshing = false;
    }
  }
  document.addEventListener('frcp.loyalty.discountApplied', () => {
    document.querySelector('.frcp-cart-rewards--modal .frcp-close-btn')?.click();
    const sidebar = document.getElementById('site-cart-sidebar');
    sidebar?.classList.add('dt-loyalty-discount-applying');
    refreshDiscountSummary();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshDiscountSummary();
  });
})();
/* FIN · DOÑA TOMASA · FROONZE: ACTUALIZAR RESUMEN */
